"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateWeightQueueBodySchema = exports.rawDailyWeightSchema = exports.metaSchema = exports.dataSchema = exports.optiweighDailyRecordsSchema = exports.optiweighRecordsSchema = exports.optiweighDetailsSchema = void 0;
const zod_1 = require("zod");
const token_1 = require("../misc/token");
exports.optiweighDetailsSchema = zod_1.z.object({
    clientId: zod_1.z.string(),
    apiKey: zod_1.z.string()
});
exports.optiweighRecordsSchema = zod_1.z.object({
    eid: zod_1.z.string(),
    visId: zod_1.z.string(),
    avWt: zod_1.z.number(),
    weightCnt: zod_1.z.number(),
    sessionId: zod_1.z.number(),
    sessionName: zod_1.z.string(),
    date: zod_1.z.string().optional(),
    gpsLat: zod_1.z.number(),
    gpsLong: zod_1.z.number()
});
exports.optiweighDailyRecordsSchema = zod_1.z.object({
    date: zod_1.z.string(),
    records: zod_1.z.array(exports.optiweighRecordsSchema)
});
exports.dataSchema = zod_1.z.object({
    clientId: zod_1.z.string(),
    clientTradingName: zod_1.z.string(),
    dailyRecords: zod_1.z.array(exports.optiweighDailyRecordsSchema)
});
exports.metaSchema = zod_1.z.object({
    startDate: zod_1.z.string().nullable(),
    endDate: zod_1.z.string().nullable(),
    days: zod_1.z.number().nullable(),
    animals: zod_1.z.number()
});
exports.rawDailyWeightSchema = zod_1.z.object({
    data: exports.dataSchema,
    meta: exports.metaSchema
});
exports.UpdateWeightQueueBodySchema = zod_1.z.object({
    auth: zod_1.z.string(),
    businessId: zod_1.z.string(),
    scope: zod_1.z.literal("optiweight"),
    userId: zod_1.z.string(),
    externalIds: token_1.ExternalIdsSchema.pick({
        rfid: true
    }).required(),
    type: zod_1.z.string(),
    details: zod_1.z.array(exports.optiweighRecordsSchema.omit({
        eid: true
    })),
    createdAt: zod_1.z.string()
});
